import styles from "@/styles/components/loading.module.scss";

import classNames from "classnames/bind";
const css = classNames.bind(styles);

export const Loading = ({ className }) => {
  return <div className={css({ loader: true, [className]: className })} />;
};
